import { ContentText } from '../../global-types/AdvisoryContent';
import './Tagline.css';

type TaglineProps = {
  text: ContentText;
};

function Tagline({ text }: TaglineProps) {
  return (
    <div id="advisory-tag" className={`if tag ${text.classNames}`}>
      {text.icon && (
        <span>
          <ids-icon {...{ [text.icon.name]: true, [`${text.icon.group}-16`]: true }} />
        </span>
        )}
      <span className="if typography ui small">{text.value}</span>
    </div>
  );
};

export default Tagline;
